import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomerService } from 'src/app/api/services/customer.service';
import { HeaderNavComponent } from 'src/app/ui/header-nav/header-nav.component';

/**
 * Where the card customer lands after the provider's hosted checkout page.
 *
 * It does NOT read the outcome from the query string. Stripe appends nothing
 * trustworthy, and a success page that believes "?status=ok" can be opened by
 * anyone. It asks the server, which asks Stripe.
 *
 * `cancelled` is a separate route rather than a flag, so a customer who backs
 * out of checkout is not shown a page that spends two seconds pretending to
 * confirm a payment they never made.
 */
@Component({
  selector: 'app-payment-return',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, HeaderNavComponent],
  templateUrl: './payment-return.component.html',
})
export class PaymentReturnComponent implements OnInit {
  state: 'checking' | 'paid' | 'pending' | 'failed' | 'cancelled' | 'unknown' = 'checking';
  amount: number | null = null;
  reference = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.routeConfig?.path === 'payment/cancelled') {
      this.state = 'cancelled';
      return;
    }
    const sid = this.route.snapshot.queryParamMap.get('sid');
    this.reference = this.route.snapshot.queryParamMap.get('txn') || '';
    if (!sid) {
      // Nothing to settle against. Say so rather than claim success.
      this.state = 'unknown';
      return;
    }
    this.customerService.completeRedirectPayment(sid).subscribe({
      next: (r) => {
        this.amount = r?.amount ?? null;
        const status = String(r?.status || '').toUpperCase();
        this.state = status === 'COMPLETED' ? 'paid'
                   : status === 'FAILED'    ? 'failed'
                   : 'pending';
      },
      error: () => { this.state = 'unknown'; },
    });
  }

  backToBar(): void { this.router.navigate(['/customer']); }
}
